import React, { useState, useEffect, useRef, SetStateAction, Dispatch, useCallback } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "./../../InputComponent"
import { LanguageFactory } from '../../../factories';
import { useLanguage } from '../../../store/languageContext'
import SearchDebounceBar from '../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Table } from 'antd';
import Loading from '../../Loading';
import DataSourceTypes from './SearchTableInterface';
import { paginationSize, getPaginationSession } from '@helpers/misc/setPaginationSize'

const MEETINGROOMS = 'Meeting Rooms'

interface propsTypes {
    pageFlag?: string,
    columns: object[],
    dataSourceProps: Array<DataSourceTypes>,
    setCurrentLine: Dispatch<SetStateAction<DataSourceTypes>>,
    setAddFlag: Dispatch<SetStateAction<string>>,
    searchLabel?: string, 
    searchPlaceHloder?: string, 
    addButton?: boolean, 
    pageName?:string, 
    loadingFlag?:boolean 
    pagination: string
}

const SearchTablePublic = (props:propsTypes ) => {
    const [dataSource, setDataSource] = useState<DataSourceTypes[]>(props.dataSourceProps);
    const [total, setTotal] = useState<number>(dataSource.length)
    const [data, setData] = useState<DataSourceTypes[]>(dataSource);
    const [paginationData, setPaginationData] = useState<number>(10)
    const [ready, setReady] = useState<boolean>(false);
    

    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([])
    const loadingCom = <Loading type="large" />
    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            let newFilterData: any = {}
            props.columns.forEach((col: any) => {
                newFilterData[col['dataIndex']] = (item[col.dataIndex] == null || item[col.dataIndex] == undefined)
                    ? ''
                    : JSON.stringify(item[col.dataIndex]).toLowerCase()
            })
            return JSON.stringify(Object.values(newFilterData)).indexOf(query.toLowerCase()) > -1;

        })
        setDataSource(filterData);
    }
    const getPaginationData = useCallback(async () => {
        return await getPaginationSession(
            setPaginationData,
            props?.pagination,
        );
    }, [props?.pagination])

    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])

    useEffect(() => {
        setDataSource(props.dataSourceProps)
        setData(props.dataSourceProps)
    }, [props.dataSourceProps])

    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])

    useEffect(() => {
        console.log('here')
        const init = async() => await getPaginationData()
        init()
        setTimeout(() => setReady(true), 100)
    }, [props.pageFlag])

    // table
    return (
        <div className='tableList' style={{ padding: '0 15px', backgroundColor: '#FFFFFF' }}>
            <Grid container spacing={0} className="containerSpacing py-0">
                {props.pageFlag !== 'meetingrooms' ? <Grid item xs={12} className="p-0">
                    {props.addButton ? 
               
                    <div style={{ display: 'flex', padding:'16px 0', justifyContent: 'space-between' }}>
                        <div style={{ fontWeight: 'bold', color: '#333', fontSize: 14 }}>Rate Plans</div>
                        <div>
                            <Button className="db-add-btn" style={{ background: '#004771', color: '#fff' }} onClick={() => { props.setAddFlag('add'); window.editFunction() }}>Add</Button>
                        </div>
                    </div> : ''}
            </Grid> : ''}
                <Grid item xs={4} className="pb-0 px-0 my-0">
                    <ImputComponent
                        className='SearchBar'
                        label={props.searchLabel || 'Search'}
                        labelShrink={true}
                        value={searchTerm}
                        onChange={onChangeSearch}
                        placeholder={props.searchPlaceHloder || 'Search Rate Plans'}
                        endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                    />
                    <div className="recentlySearchs">
                        <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                    </div>
                </Grid>
                { ready && <Grid item xs={12} className="p-0">
                    <Table
                        columns={props.columns}
                        dataSource={dataSource}
                        pagination={{
                            size: "small",
                            total,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showSizeChanger: true,
                            showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                            defaultPageSize: paginationData,
                            defaultCurrent: 1,
                            onShowSizeChange: (current, size: number) => paginationSize('pagination', { [props.pagination] : size })
                        }}
                        loading={{indicator:loadingCom, spinning:!!props.loadingFlag}}
                        onRow={record => {
                            return {
                                onClick: () => {
                                    let _record = record
                                    if(props.pageName === MEETINGROOMS){
                                        if(!_record?.service || _record?.service?.length === 0){
                                            record.service = [{}]
                                        }
                                        if(!_record?.capacity || _record?.capacity?.length === 0){
                                            _record.capacity = [{}]
                                        }
                                    }
                                    props.setCurrentLine(_record)
                                    props.setAddFlag('view')
                                },
                            };
                        }}
                    />
                </Grid>}
            </Grid>
        </div>
    )
}

export default SearchTablePublic
